export default function MissionSection() {
  return (
    <section className="relative py-24 md:py-32 lg:py-40 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-4">
          <span className="text-xs tracking-widest uppercase text-foreground-400" style={{ fontFamily: 'var(--font-label)' }}>
            (about)
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-14 md:mb-20" style={{ fontFamily: 'var(--font-heading)' }}>
          A professional engineering
          <br />
          team <span className="text-foreground-400">focused on</span> quality
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          <div>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
              We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality. Every solution is crafted with precision and attention to the full software lifecycle.
            </p>
          </div>
          <div>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
              Our team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design. We believe that well-engineered systems speak for themselves through their reliability and longevity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}